<template>
  <ConfirmationModal
    :bodyText="bodyText"
    cancelText=""
    continueText="ok"
    headerText="User schema preview"
  >
    <div
      v-if="!isBodyEmpty"
      data-test-id="IdmUserPreviewModal_content"
    >
      <div>
        <TextArea
          data-test-id="IdmCustom_SpResponse"
          :disabled="true"
          label="Returned from the service provider"
          :name="'sp response'"
          :resizeable="false"
          :value="spMap"
        />
      </div>
      <div>
        <TextArea
          data-test-id="IdmCustom_attributeMapping"
          :disabled="true"
          label="JumpCloud schema with applied mappings"
          :name="'jc attributes'"
          :resizeable="false"
          :value="jcMap"
        />
      </div>
    </div>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import TextArea from 'client/components/FormValidation/Textarea.vue';

export default {
  name: 'IdmUserPreviewModal',

  components: {
    ConfirmationModal,
    TextArea,
  },

  props: {
    jcMappedSchema: {
      type: Object,
      default() { return {}; },
      required: true,
    },
    spUserSchema: {
      type: Object,
      default() { return {}; },
      required: true,
    },
  },

  data() {
    return {
      jcMap: '',
      spMap: '',
      isBodyEmpty: false,
    };
  },

  computed: {
    bodyText() {
      if (this.isBodyEmpty) {
        return `Hmmm. We did not find any user profiles in the 
        service provider you're trying to connect to.`;
      }
      return '';
    },
  },

  async mounted() {
    if (Object.keys(this.spUserSchema).length === 0) {
      this.isBodyEmpty = true;
      return;
    }

    this.spMap = this.toJsonString(this.spUserSchema);
    this.jcMap = this.toJsonString(this.jcMappedSchema);
  },

  methods: {
    toJsonString(obj) {
      return JSON.stringify(obj, ' ', 2);
    },
  },
};
</script>
